import type { ViewRenderer } from ".";
import { SvgService } from "../../../services/SvgService";
import { RENDERING } from "../../../config/constants";

export const dotRenderer: ViewRenderer = (
	svgElem,
	delaunayTriangles,
	canvas,
) => {
	const { points, selectedPoints, showVertices } = canvas;

	// Create circles using DocumentFragment for better performance
	const circleElements: SVGCircleElement[] = [];

	// Create shapes
	for (let i = 0; i < delaunayTriangles.length; i += 3) {
		const p1 = delaunayTriangles[i];
		const p2 = delaunayTriangles[i + 1];
		const p3 = delaunayTriangles[i + 2];

		// Calculate center point of triangle
		const centerX = (points[p1][0] + points[p2][0] + points[p3][0]) / 3;
		const centerY = (points[p1][1] + points[p2][1] + points[p3][1]) / 3;

		// Create ellipse instead of polygon
		const circle = SvgService.createSvgElement("circle");

		circle.setAttribute("cx", centerX.toString());
		circle.setAttribute("cy", centerY.toString());
		circle.setAttribute("r", RENDERING.DOT_RADIUS.toString());

		// Randomly select color from palette
		circle.setAttribute("fill", "currentColor");

		circleElements.push(circle);
	}

	// Batch append all circles
	SvgService.batchAppendChildren(svgElem, circleElements);

	// Add individual point circles for selection (if enabled)
	if (showVertices) {
		const pointElements: SVGCircleElement[] = [];
		points.forEach((point, index) => {
			const pointCircle = SvgService.createSvgElement("circle");
			pointCircle.setAttribute("cx", point[0].toString());
			pointCircle.setAttribute("cy", point[1].toString());
			pointCircle.setAttribute("r", "4");
			pointCircle.setAttribute(
				"fill",
				selectedPoints.includes(index) ? "#ff6b35" : "#333",
			);
			pointCircle.setAttribute(
				"stroke",
				selectedPoints.includes(index) ? "#ff6b35" : "#666",
			);
			pointCircle.setAttribute("stroke-width", "2");
			pointCircle.setAttribute("cursor", "pointer");
			pointCircle.dataset.pointIndex = index.toString();
			pointElements.push(pointCircle);
		});

		SvgService.batchAppendChildren(svgElem, pointElements);
	}
};
